module.exports = __webpack_public_path__ + "img/select.b3932f16.svg";